export function verifyIfPathIsActive(path: string, isSubpage = true) {
  if (!isSubpage) {
    return window.location.pathname.includes(path);
  }

  return window.location.pathname === path;
}
